import React from 'react';

import classes from './ListHeader.module.scss';

type ListHeaderProps = {
    title: string;
    // Links and the create button, shown on the right of the title
    children: React.ReactNode;
};

/** Title row of a list view, with links and actions on the same line. */
export const ListHeader = ({ title, children }: ListHeaderProps) => (
    <div className={classes.header}>
        <h2>{title}</h2>
        <div className={classes.actions}>{children}</div>
    </div>
);
